import { render, staticRenderFns } from "./NewVideoView.vue?vue&type=template&id=7105d42a"
import script from "./NewVideoView.vue?vue&type=script&lang=js"
export * from "./NewVideoView.vue?vue&type=script&lang=js"
import style0 from "./NewVideoView.vue?vue&type=style&index=0&id=7105d42a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports